import { graphql } from '@/gql';
import type { SearchMessagesQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { PaginatedSearchMessageTypeResponse } from '@/models/chatRoom';

export const searchMessages = async ({
  searchTerm,
  pagination,
}: SearchMessagesQueryVariables): Promise<PaginatedSearchMessageTypeResponse> => {
  const response = await queryExecute({
    query: graphql(`
      query SearchMessages($searchTerm: String!, $pagination: PaginationInputType) {
        searchMessages(searchTerm: $searchTerm, pagination: $pagination) {
          count
          rows {
            id
            chatRoomId
            fromNumber
            message
            isRead
            phoneNumber1
            phoneNumber2
            callerName
            createdAt
            updatedAt
          }
        }
      }
    `),
    variables: {
      searchTerm,
      pagination,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.searchMessages;
};
